import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CapacitateCrestereComponent } from './capacitate-crestere.component';
import { AddCapacitateCrestereComponent } from './add-capacitate-crestere/add-capacitate-crestere.component';
import { EditCapacitateCrestereComponent } from './edit-capacitate-crestere/edit-capacitate-crestere.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
    declarations: [
        CapacitateCrestereComponent,
        AddCapacitateCrestereComponent,
        EditCapacitateCrestereComponent
    ],
    imports: [
        CommonModule, MaterialModule, FormsModule, ReactiveFormsModule
    ],
    exports: [CapacitateCrestereComponent],
})
export class CapacitateCrestereModule { }
